
import { ServiceError, WebServiceBase, WebServiceResponse } from 'app/services/WebServiceBase'
import * as utils from 'app/utils'

// supply some error messages for our domains
ServiceError.domainCatalogs.Workbooks = {
  100: 'There are no free resources to handle this request'
}

class MiscService extends WebServiceBase {
  protected apiEndpoint: string

  constructor(protected serviceEndpoint: string) {
    super()
    this.apiEndpoint = this.serviceEndpoint + 'api/misc/'
  }

  public exportTransactions(accessToken: string, filename: string, contents: string): Promise<WebServiceResponse> {
    const uri = this.apiEndpoint + 'exportTransactions'
    const payload = { filename, contents }
    const req = this.requestOptions(uri, payload, accessToken, { method: 'POST' })
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(WebServiceResponse.fromJSON)
      .then((fr: WebServiceResponse) => {
        if (fr.IsError) { throw fr }
        // tslint:disable-next-line:no-console
        console.log('Misc.exportTransactions worked. ' + JSON.stringify(fr))
        return fr
      })
      .catch((reason) => {
        // tslint:disable:no-console
        console.log('Misc.exportTransactions failed. ' + JSON.stringify(reason, undefined, 4))
        throw reason
      });
  }

  public getLifeExpectancyTable(): Promise<any> {
    const uri = this.apiEndpoint + 'GetLifeExpectancyTable'
    const req = this.requestOptions(uri, {
      method: 'GET',
      qheaders: new Headers({
        'Accept': 'text/csv; charset=utf-8',
        'Content-Type': 'application/json'
      })
    })
    return utils.xfetch(uri).then((response) => response.json())
  }

  public getExtraInfo(accessToken: string): Promise<any> {
    const uri = this.apiEndpoint + 'GetExtraInfo'
    const req = this.requestOptions(uri, undefined, accessToken, { method: 'GET' })
    return utils.xfetch(req)
    .then((response) => response.json())
  }

  public reflectFile(accessToken: string, filename: string, contents: string, mediaType: string): Promise<WebServiceResponse> {
    const uri = this.apiEndpoint + 'reflectFile'
    const payload = { filename, contents, mediaType }
    const req = this.requestOptions(uri, payload, accessToken, {
      method: 'GET',
      qheaders: new Headers({
        'Accept': 'text/csv; charset=utf-8',
        'Content-Type': 'application/json'
      })
    })
    return utils.xfetch(req)
      .then((response) => response.json())
      .then(WebServiceResponse.fromJSON)
      .then((fr: WebServiceResponse) => {
        if (fr.IsError) { throw fr }
        // tslint:disable-next-line:no-console
        //console.log('Misc.reflectFile worked. ' + JSON.stringify(fr))
        return fr
      })
      .catch((reason) => {
        // tslint:disable:no-console
        console.log('Misc.reflectFile failed. ' + JSON.stringify(reason, undefined, 4))
        throw reason
      });
  }
}

export {
  MiscService
}



// WEBPACK FOOTER //
// ./src/app/services/MiscService/index.ts